/**Angular imports.*/
import { Component, Input, ViewContainerRef, OnInit } from '@angular/core';

@Component({
    selector: 'dynamic-layout-tag',
    template: '',
    standalone: false
})
export class DynamicLayout implements OnInit {
    @Input() componentTypes: any;
    @Input() FrameworkObj: any;
    @Input() ItemsList: any;


    constructor(private viewContainerRef: ViewContainerRef) {

    }
    ngOnInit() {
        const ref = this;
        const componentRef = this.viewContainerRef.createComponent(this.componentTypes);
        (componentRef.instance as any)['FrameworkObj'] = this.FrameworkObj;
    }
}
